import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {RestApiService} from '../../http/rest-api.service';
import {Observable} from 'rxjs';
import {ApiCountriesListResponse} from './api-countries-list-response';
import {LanguageService} from '../../language/language.service';
import {AuthApiRoutesEnum} from '../../http/auth-api-routes.enum';

@Injectable()
export class CountryRestApiService {

  constructor(
    private readonly _httpClient: HttpClient,
    private readonly _restApiService: RestApiService,
    private readonly _languageService: LanguageService,
  ) {
  }

  public requestCountryList(): Observable<ApiCountriesListResponse> {
    const url: string = [
      this._restApiService.authApiUrl,
      AuthApiRoutesEnum.COUNTRIES,
    ].join('/');
    const params: HttpParams = this._restApiService.createHttpParams({lang: this._languageService.activeLanguage});
    return this._httpClient.get<ApiCountriesListResponse>(url, {params: params});
  }
}
